import cloneDeep from 'lodash/cloneDeep';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

const initState = {
  formInfo: {},
  editForm: {
    infraction_type: null,
    admin_comments: null,
  },
  loading: false,
  saving: false,
};

function onLoadFormData(state) {
  return {
    ...state,
    loading: true,
  };
}

function onAddRequest(state) {
  return {
    ...state,
    saving: true,
  };
}

function onLoadFormDataSuccess(state, { payload }) {
  const { formInfo } = payload;

  return {
    ...state,
    formInfo,
    loading: false,
  };
}

function onValueChange(state, { payload }) {
  const { key, value } = payload;

  const editForm = cloneDeep(state.editForm);

  editForm[key] = value;

  return { ...state, editForm };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.ADD_REQUEST]: onAddRequest,
  [actions.CHANGE_VALUE]: onValueChange,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD_REQUEST]: onLoadFormData,
  [actions.LOAD_SUCCESS]: onLoadFormDataSuccess,
});
